import { useAtomValue } from 'jotai';

import { useRecordingControl as useBaseRecordingControl } from '../../session/controls/useRecordingControl';
import { sessionAppointmentShortIdAtom } from '../state';

export function useRecordingControl() {
  const hasAppointment = !!useAtomValue(sessionAppointmentShortIdAtom);
  return useBaseRecordingControl(hasAppointment);
}
